import React, { useState } from 'react';
import './ArchiveListTable.scss';
import { Table, Tag, Tooltip } from 'antd';
import ShipmentListCardOptions from '../../../ShipmentList/ShipmentListCardOptions/ShipmentListCardOptions';
import { getIcon } from '../../../../utils/images';
import { Cargo, Logo, ReferenceNumber, RouteTrack, Status } from './ColumnComponents';

const ArchiveListTable = ({ shipments, selectShipment, refetch, tagSummary, readableOnly }) => {
  const [shipmentOptionsOpened, setShipmentOptionsOpened] = useState(null);

  const clickRow = (shipment) => {
    selectShipment(shipment);
    setShipmentOptionsOpened(null);
  };

  let columns = [
    {
      title: '',
      dataIndex: 'star',
      key: 'icon',
      render: (star, shipment) => {
        return <Logo star={star} shipment={shipment} getIcon={getIcon} clickRow={clickRow} />;
      },
      width: '5%',
    },
    {
      title: 'Ref #',
      dataIndex: 'booking_number',
      key: 'booking_number',
      render: (booking_number, shipment) => {
        return <ReferenceNumber booking_number={booking_number} shipment={shipment} clickRow={clickRow} />;
      },
      width: '10%',
    },
    {
      title: 'Route',
      dataIndex: '',
      key: 'track',
      className: 'centered',
      render: (_, shipment) => <RouteTrack shipment={shipment} clickRow={clickRow} />,
    },
    {
      title: 'Status',
      dataIndex: 'state',
      key: 'state',
      render: (state, shipment) => <Status state={state} shipment={shipment} clickRow={clickRow} />,
      width: '20%',
    },
    {
      title: 'Cargo',
      dataIndex: 'cargo',
      key: 'cargo',
      className: 'cargo-col',
      render: (cargo, shipment) => <Cargo cargo={cargo} shipment={shipment} clickRow={clickRow} />,
      width: '12%',
    },
    {
      title: '',
      dataIndex: 'tags',
      key: 'tags',
      className: 'wide',
      render: (tags, shipment) => {
        return (
          tags ?
            (
              tags.length
                ?
                <>
                  <div className="tags" onClick={() => clickRow(shipment)}>{tagSummary(tags, true)}</div>
                  <div className="tags-short" onClick={() => clickRow(shipment)}>{tagSummary(tags)}</div>
                </>
                : <></>
            ) : <></>
        );
      },
      width: '12%',
    },
    {
      title: '',
      dataIndex: '',
      key: 'popover',
      render: (_, shipment) => {
        return (
          <ShipmentListCardOptions shipment={shipment} refetch={refetch} shipmentOptionsOpened={shipmentOptionsOpened}
                                   setShipmentOptionsOpened={setShipmentOptionsOpened} readableOnly={readableOnly} />
        );
      },
      width: '5%',
    },
  ];

  columns = columns.filter((c) => Object.keys(c).length);

  const expandedColumns = [
    {
      title: '',
      dataIndex: '',
      key: 'left-pad',
      className: 'ant-table-row-expand-icon-cell',
      width: '18px',
    },
    ...columns,
  ];

  return (
    <div className="ArchiveListTable">
      <Table
        tableLayout="fixed"
        rowClassName={'ant-table-row'}
        dataSource={shipments}
        columns={columns}
        pagination={{ position: ['none', 'none'], pageSize: 25 }}
        rowKey="id"
        expandable={{
          expandedRowRender: (record) => (
            <div className="listing-table-wrapper">
              <Table
                tableLayout="fixed"
                className="listing-table"
                rowClassName={'ant-table-row'}
                dataSource={record.group}
                columns={expandedColumns}
                rowKey="id"
                showHeader={false}
                pagination={false}
              />
            </div>
          ),
          columnWidth: '18px',
          expandIcon: ({ expanded, onExpand, record }) => {
            return record.group.length > 1 &&
              <div className="expand-icon"><img className={expanded ? 'expanded' : ''} src={getIcon('table-expand')}
                                                onClick={e => onExpand(record, e)} /></div>;
          },
        }}
      />
    </div>
  );
};

export default ArchiveListTable;
